webpackJsonp([114276838955818],{

/***/ 85:
/***/ (function(module, exports) {

	module.exports = {"data":{"user":{"edges":[{"node":{"userFullName":"thebroomwagon","code":"By7i-4-IVRc","userBio":"Enjoy • Cycling • Together • Girona\n🚲 • ❤️ • ☕️\nGet in touch for personalized trips or the Broomwagon at your event!\nInfo@thebroomwagongirona.com","userFollowers":3008,"userPostCount":151,"id":"2070402309067723868","userName":"thebroomwagon","likes":186,"comment":2,"text":"Our new jersey has a little zipper on one of the pockets. Perfect for coins, ID-cards etc.\n•\nFor more info send me a message.\n•\n#broombroombroom #thebroomwagongirona #girona #cyclinggear #coffeespecialty","type":"GraphImage","image":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAMEAv/EABUBAQEAAAAAAAAAAAAAAAAAAAQD/9oADAMBAAIQAxAAAAGkrc3JgWQVqsWNiB1//8QAHBAAAgICAwAAAAAAAAAAAAAAAhEAAQMSITJB/9oACAEBAAEFAkN3kJRQht5B51cLuU9//8QAGBEAAwEBAAAAAAAAAAAAAAAAAAExAjL/2gAIAQMBAT8BcM8ocEf/xAAXEQADAQAAAAAAAAAAAAAAAAAAARAx/9oACAECAQE/AR7f/8QAGxAAAgEFAAAAAAAAAAAAAAAAAAEQAhEhIjH/2gAIAQEABj8C2ZaMKOlMM//EAB0QAQACAgIDAAAAAAAAAAAAAAEAESExUfBhgZH/2gAIAQEAAT8hzCCeY6QpUV1l1mEl9+SU2p6jw92QXUT7T//aAAwDAQACAAMAAAAQkwjA/8QAGBEBAQEBAQAAAAAAAAAAAAAAAQAxEXH/2gAIAQMBAT8QPAk08LCwX//EABcRAQEBAQAAAAAAAAAAAAAAAAABMSH/2gAIAQIBAT8Ql62Rdf/EABwQAQADAAMBAQAAAAAAAAAAAAEAESExQWGB4f/aAAgBAQABPxCtrlRjs/Jx9wvkclbhrRi3oHnqZ/EH7CwojK1G0YpfsAqeoHD3n//Z","aspectRatio":1,"src":"/static/By7i-4-IVRc-7cb48b90aabb87e87eec17b27aff66bc-4d9a2.jpg","srcSet":"/static/By7i-4-IVRc-7cb48b90aabb87e87eec17b27aff66bc-4a98d.jpg 58w,\n/static/By7i-4-IVRc-7cb48b90aabb87e87eec17b27aff66bc-5b35d.jpg 115w,\n/static/By7i-4-IVRc-7cb48b90aabb87e87eec17b27aff66bc-4d9a2.jpg 230w,\n/static/By7i-4-IVRc-7cb48b90aabb87e87eec17b27aff66bc-f7f35.jpg 345w,\n/static/By7i-4-IVRc-7cb48b90aabb87e87eec17b27aff66bc-e2f4c.jpg 460w,\n/static/By7i-4-IVRc-7cb48b90aabb87e87eec17b27aff66bc-3bfa7.jpg 640w","sizes":"(max-width: 230px) 100vw, 230px","originalName":"By7i-4-IVRc.jpg"}}}}}]},"posts":{"edges":[{"node":{"id":"2070402309067723868","code":"By7i-4-IVRc","likes":186,"comment":2,"type":"GraphImage","text":"Our new jersey has a little zipper on one of the pockets. Perfect for coins, ID-cards etc.\n•\nFor more info send me a message.\n•\n#broombroombroom #thebroomwagongirona #girona #cyclinggear #coffeespecialty","image":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAMEAv/EABUBAQEAAAAAAAAAAAAAAAAAAAQD/9oADAMBAAIQAxAAAAGkrc3JgWQVqsWNiB1//8QAHBAAAgICAwAAAAAAAAAAAAAAAhEAAQMSITJB/9oACAEBAAEFAkN3kJRQht5B51cLuU9//8QAGBEAAwEBAAAAAAAAAAAAAAAAAAExAjL/2gAIAQMBAT8BcM8ocEf/xAAXEQADAQAAAAAAAAAAAAAAAAAAARAx/9oACAECAQE/AR7f/8QAGxAAAgEFAAAAAAAAAAAAAAAAAAEQAhEhIjH/2gAIAQEABj8C2ZaMKOlMM//EAB0QAQACAgIDAAAAAAAAAAAAAAEAESExUfBhgZH/2gAIAQEAAT8hzCCeY6QpUV1l1mEl9+SU2p6jw92QXUT7T//aAAwDAQACAAMAAAAQkwjA/8QAGBEBAQEBAQAAAAAAAAAAAAAAAQAxEXH/2gAIAQMBAT8QPAk08LCwX//EABcRAQEBAQAAAAAAAAAAAAAAAAABMSH/2gAIAQIBAT8Ql62Rdf/EABwQAQADAAMBAQAAAAAAAAAAAAEAESExQWGB4f/aAAgBAQABPxCtrlRjs/Jx9wvkclbhrRi3oHnqZ/EH7CwojK1G0YpfsAqeoHD3n//Z","aspectRatio":1,"src":"/static/By7i-4-IVRc-7cb48b90aabb87e87eec17b27aff66bc-8a56f.jpg","srcSet":"/static/By7i-4-IVRc-7cb48b90aabb87e87eec17b27aff66bc-e4adc.jpg 20w,\n/static/By7i-4-IVRc-7cb48b90aabb87e87eec17b27aff66bc-e4ca8.jpg 40w,\n/static/By7i-4-IVRc-7cb48b90aabb87e87eec17b27aff66bc-8a56f.jpg 80w,\n/static/By7i-4-IVRc-7cb48b90aabb87e87eec17b27aff66bc-a73ed.jpg 120w,\n/static/By7i-4-IVRc-7cb48b90aabb87e87eec17b27aff66bc-7f0a7.jpg 160w,\n/static/By7i-4-IVRc-7cb48b90aabb87e87eec17b27aff66bc-02301.jpg 240w,\n/static/By7i-4-IVRc-7cb48b90aabb87e87eec17b27aff66bc-21ad6.jpg 640w","sizes":"(max-width: 80px) 100vw, 80px","originalName":"By7i-4-IVRc.jpg"}}}}},{"node":{"id":"2066980471662849725","code":"ByvY8mjIi69","likes":183,"comment":1,"type":"GraphSidecar","text":"Wow, that was an amazing week full of cycling, smiles and good cups of coffee.\nThanks everyone for joining the @gironacyclingfestival and coming over! •\n•\n🚲•❤️•☕️\n•\n•\n#Cycling #Piaggo #Girona #Bikes #Coffee #RocketEspresso","image":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGQABAQADAQAAAAAAAAAAAAAAAAQBAgMF/8QAFgEBAQEAAAAAAAAAAAAAAAAAAQIA/9oADAMBAAIQAxAAAAGL1INyMJg1chq4O//EAB0QAAIBBAMAAAAAAAAAAAAAAAABAgMEETESEyH/2gAIAQEAAQUCpeHbAuZcqsNNtmGS1BYez//EABYRAQEBAAAAAAAAAAAAAAAAAAERIP/aAAgBAwEBPwFYzH//xAAXEQEAAwAAAAAAAAAAAAAAAAABABAR/9oACAECAQE/AQmX/8QAHBAAAgICAwAAAAAAAAAAAAAAAAECIRARMlGh/9oACAEBAAY/Al0VGQ2VtaGlJnLzFY//xAAbEAEAAgMBAQAAAAAAAAAAAAABABEhMUFRcf/aAAgBAQABPyFqSXbkSbI3jE45gmiUVQK9nvX6puh3wmzP/9oADAMBAAIAAwAAABA72ED/xAAWEQEBAQAAAAAAAAAAAAAAAAABIDH/2gAIAQMBAT8QEkbH/8QAFxEBAQEBAAAAAAAAAAAAAAAAAQAREP/aAAgBAgEBPxDcW1wv/8QAHBABAQADAAMBAAAAAAAAAAAAAREAITFBUWGx/9oACAEBAAE/EHq+QVpd8yKIKLjGjPcwDaGQmzR37hAX3WJd2XK9a2J3ezL816r/ADEwNaTNzC93rmEvJ8c//9k=","aspectRatio":1,"src":"/static/ByvY8mjIi69-3d37737dfcd50f6dad498556bd6cc17a-8a56f.jpg","srcSet":"/static/ByvY8mjIi69-3d37737dfcd50f6dad498556bd6cc17a-e4adc.jpg 20w,\n/static/ByvY8mjIi69-3d37737dfcd50f6dad498556bd6cc17a-e4ca8.jpg 40w,\n/static/ByvY8mjIi69-3d37737dfcd50f6dad498556bd6cc17a-8a56f.jpg 80w,\n/static/ByvY8mjIi69-3d37737dfcd50f6dad498556bd6cc17a-a73ed.jpg 120w,\n/static/ByvY8mjIi69-3d37737dfcd50f6dad498556bd6cc17a-7f0a7.jpg 160w,\n/static/ByvY8mjIi69-3d37737dfcd50f6dad498556bd6cc17a-02301.jpg 240w,\n/static/ByvY8mjIi69-3d37737dfcd50f6dad498556bd6cc17a-21ad6.jpg 640w","sizes":"(max-width: 80px) 100vw, 80px","originalName":"ByvY8mjIi69.jpg"}}}}},{"node":{"id":"2065299956270412813","code":"Bypa14oILQN","likes":174,"comment":18,"type":"GraphSidecar","text":"Our new jersey is here!\n•\nTogether with @tacticsport we designed a new cycling kit for men and women. Fresh colors, our own #bikelovecoffee sign and of course the race stripes 😀\n• \nCome and check it out @gironacyclingfestival •\n#broombroombroom #thebroomwagongirona #cycling #cylinggear #girona #bikebreaksgirona #menandwomen","image":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAECAwT/xAAVAQEBAAAAAAAAAAAAAAAAAAAEA//aAAwDAQACEAMQAAABzWrFrgOv0QqfAij/xAAbEAACAwADAAAAAAAAAAAAAAABEQACEBIyQf/aAAgBAQABBQInOSntkI3KdrDP/8QAGREAAgMBAAAAAAAAAAAAAAAAEBIBAjEy/9oACAEDAQE/AZZ9Fuh//8QAGREAAQUAAAAAAAAAAAAAAAAAEAECERIy/9oACAECAQE/AUiobkf/xAAcEAABAwUAAAAAAAAAAAAAAAAAAQIQERIhMXH/2gAIAQEABj8C2XVlxkUXsf/EABoQAQADAQEBAAAAAAAAAAAAAAEAESExQVH/2gAIAQEAAT8hR5Yua2rV5DhkfIbMx+YSm7rNN8ITZ7SOz//aAAwDAQACAAMAAAAQSw/D/8QAGREAAwADAAAAAAAAAAAAAAAAAAERECGx/9oACAEDAQE/EHsmFZs7rH//xAAZEQADAAMAAAAAAAAAAAAAAAAAAREQIcH/2gAIAQIBAT8QWTg2ro6Y/8QAHBABAQACAwEBAAAAAAAAAAAAAREAITFBkXGB/9oACAEBAAE/EHnQRNXWW8xKlYfuCeKdJxkBXWm9bxLqKAO2ZSlxamOobAPcGFRu8xVX5n//2Q==","aspectRatio":1,"src":"/static/Bypa14oILQN-ad58e55d8738533535c3997c85e9b08c-8a56f.jpg","srcSet":"/static/Bypa14oILQN-ad58e55d8738533535c3997c85e9b08c-e4adc.jpg 20w,\n/static/Bypa14oILQN-ad58e55d8738533535c3997c85e9b08c-e4ca8.jpg 40w,\n/static/Bypa14oILQN-ad58e55d8738533535c3997c85e9b08c-8a56f.jpg 80w,\n/static/Bypa14oILQN-ad58e55d8738533535c3997c85e9b08c-a73ed.jpg 120w,\n/static/Bypa14oILQN-ad58e55d8738533535c3997c85e9b08c-7f0a7.jpg 160w,\n/static/Bypa14oILQN-ad58e55d8738533535c3997c85e9b08c-02301.jpg 240w,\n/static/Bypa14oILQN-ad58e55d8738533535c3997c85e9b08c-21ad6.jpg 640w","sizes":"(max-width: 80px) 100vw, 80px","originalName":"Bypa14oILQN.jpg"}}}}},{"node":{"id":"2064803623726114720","code":"Bynp_S7Imeg","likes":170,"comment":3,"type":"GraphImage","text":"Yes!! We made it to the top ⛰\n•\n13, 14 and 15 of June you can find us at the Race Village.\n•\n13th: 9 till noon\n14th: 9 till noon\n15th: 9 till the finish •\n#thebroomwagongirona #gironagrandfondo #broombroombroom #cycling #cyclingcoffee #cyclinggear #girona #horscategoriegirona","image":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGQABAAIDAAAAAAAAAAAAAAAAAAMEAQIF/8QAFwEBAAMAAAAAAAAAAAAAAAAAAgABA//aAAwDAQACEAMQAAAB1r5BQLiGtKK+uM3/AP/EABwQAAMAAgMBAAAAAAAAAAAAAAABAgMRBBQhI//aAAgBAQABBQLM91vx0im28cOjqyI47+x//8QAGBEAAwEBAAAAAAAAAAAAAAAAAAECERD/2gAIAQMBAT8BqGYa+f/EABcRAQADAAAAAAAAAAAAAAAAAAEAEBH/2gAIAQIBAT8BJhf/xAAdEAABBAIDAAAAAAAAAAAAAAAAARARIQISQoGR/9oACAEBAAY/AqeUQ1ymDl6VVHTf/8QAGhABAAMBAQEAAAAAAAAAAAAAAQARITFxwf/aAAgBAQABPyEdVp3eRo+wTTr7MZL6EvGfWNEb34ROmG8iV9Rn/9oADAMBAAIAAwAAABCcMD7/xAAZEQADAAMAAAAAAAAAAAAAAAAAAREQITH/2gAIAQMBAT8QgTSKFwusf//EABcRAQEBAQAAAAAAAAAAAAAAAAEQETH/2gAIAQIBAT8QRxYIZs//xAAcEAEBAAMBAQEBAAAAAAAAAAABEQAhMUFRkaH/2gAIAQEAAT8QIMxIrrE2rfcTrDqMyS5Btc+/uQ4Ygob6ZbQ3cE/uUIYI+ovtw41RbbfM65n/2Q==","aspectRatio":1,"src":"/static/Bynp_S7Imeg-66da5201e835a8c040943f2dc6cd6770-8a56f.jpg","srcSet":"/static/Bynp_S7Imeg-66da5201e835a8c040943f2dc6cd6770-e4adc.jpg 20w,\n/static/Bynp_S7Imeg-66da5201e835a8c040943f2dc6cd6770-e4ca8.jpg 40w,\n/static/Bynp_S7Imeg-66da5201e835a8c040943f2dc6cd6770-8a56f.jpg 80w,\n/static/Bynp_S7Imeg-66da5201e835a8c040943f2dc6cd6770-a73ed.jpg 120w,\n/static/Bynp_S7Imeg-66da5201e835a8c040943f2dc6cd6770-7f0a7.jpg 160w,\n/static/Bynp_S7Imeg-66da5201e835a8c040943f2dc6cd6770-02301.jpg 240w,\n/static/Bynp_S7Imeg-66da5201e835a8c040943f2dc6cd6770-21ad6.jpg 640w","sizes":"(max-width: 80px) 100vw, 80px","originalName":"Bynp_S7Imeg.jpg"}}}}},{"node":{"id":"2040177799579605154","code":"BxQKuY-lJii","likes":169,"comment":6,"type":"GraphImage","text":"Fun event at our friends of @tacticsport with @eat_sleep_cycle ! Coffees for the cyclists and staff. We love to work with companies who are this passionate about riding bikes! •\n•🚲•♥️•☕️•\n•\n•\n#cycling #Coffee #thebroomwagongirona #CoffeeRide #Girona #Rocketespresso #magistralecyclingcoffee #broombroombroom","image":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAMEAgX/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAG8XR5LSM1QoD//xAAaEAEAAwEBAQAAAAAAAAAAAAACAQMSAAQi/9oACAEBAAEFArcQIsIrsalP455dU+bXbSsDmLsme//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8BH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8BH//EAB8QAAIBBAIDAAAAAAAAAAAAAAABEQISITEiQQNhof/aAAgBAQAGPwKrx6fpC51SctiUZgdOLlsm/wCEt9lvT2S0f//EABwQAQEBAAMAAwAAAAAAAAAAAAERACExQWFxgf/aAAgBAQABPyFlVjirSnpK5+y/hyoBwFuXyAF61NLrECrhkICvjvBeW/bv/9oADAMBAAIAAwAAABDwwAD/xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/EB//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/EB//xAAdEAEAAwACAwEAAAAAAAAAAAABABEhMUFRgbHB/9oACAEBAAE/EKmdIcWjZA1baF7AL0cbKWOAr9KhvpvTqzxfNQsLoNkdad5UMiFHllRGKQR4fXqYNpDZOtK/kDBc1r+M/9k=","aspectRatio":1,"src":"/static/BxQKuY-lJii-1967deef51e1a793e705b76a1bc48ffd-8a56f.jpg","srcSet":"/static/BxQKuY-lJii-1967deef51e1a793e705b76a1bc48ffd-e4adc.jpg 20w,\n/static/BxQKuY-lJii-1967deef51e1a793e705b76a1bc48ffd-e4ca8.jpg 40w,\n/static/BxQKuY-lJii-1967deef51e1a793e705b76a1bc48ffd-8a56f.jpg 80w,\n/static/BxQKuY-lJii-1967deef51e1a793e705b76a1bc48ffd-a73ed.jpg 120w,\n/static/BxQKuY-lJii-1967deef51e1a793e705b76a1bc48ffd-7f0a7.jpg 160w,\n/static/BxQKuY-lJii-1967deef51e1a793e705b76a1bc48ffd-02301.jpg 240w,\n/static/BxQKuY-lJii-1967deef51e1a793e705b76a1bc48ffd-21ad6.jpg 640w","sizes":"(max-width: 80px) 100vw, 80px","originalName":"BxQKuY-lJii.jpg"}}}}},{"node":{"id":"2029710579267356773","code":"Bwq-wSaFUhl","likes":298,"comment":4,"type":"GraphImage","text":"It’s time to drive this beauty to @tacticsport for an event with @eat_sleep_cycle.\n\n#broombroombroom #thebroomwagongirona #bianchibenelux #celeste #bikelovecoffee #girona","image":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAQADAAAAAAAAAAAAAAAAAAMBAgT/xAAXAQADAQAAAAAAAAAAAAAAAAABAgMA/9oADAMBAAIQAxAAAAFaWgGEi1hzjyuG3//EABoQAQACAwEAAAAAAAAAAAAAAAEAAhESITH/2gAIAQEAAQUCrWpGJ2nl1zybK72g8//EABgRAAMBAQAAAAAAAAAAAAAAAAABERAT/9oACAEDAQE/AeqsKRZ//8QAGBEAAgMAAAAAAAAAAAAAAAAAABEBEBL/2gAIAQIBAT8BxKFf/8QAGRAAAgMBAAAAAAAAAAAAAAAAADEQESFB/9oACAEBAAY/AryeGUMY4//EABwQAQACAgMBAAAAAAAAAAAAAAEAIRExQVFhcf/aAAgBAQABPyHAICcyx9ncYgsQi4a8i5WYYdRXDDvxrZ3P/9oADAMBAAIAAwAAABALz/8A/8QAGhEAAgIDAAAAAAAAAAAAAAAAAREAECExUf/aAAgBAwEBPxBZrqIcw8K//8QAFhEBAQEAAAAAAAAAAAAAAAAAABEB/9oACAECAQE/EKUpdY//xAAcEAEBAAMBAAMAAAAAAAAAAAABEQAhYTFRgaH/2gAIAQEAAT8QBigrCn3hLB423b3KJhy5FqemIwmKKBr3EvZvzcIFhOwcqu99Vr+4kJLsrn//2Q==","aspectRatio":1,"src":"/static/Bwq-wSaFUhl-7fae7537cd2446aee43f6c213054a2ea-8a56f.jpg","srcSet":"/static/Bwq-wSaFUhl-7fae7537cd2446aee43f6c213054a2ea-e4adc.jpg 20w,\n/static/Bwq-wSaFUhl-7fae7537cd2446aee43f6c213054a2ea-e4ca8.jpg 40w,\n/static/Bwq-wSaFUhl-7fae7537cd2446aee43f6c213054a2ea-8a56f.jpg 80w,\n/static/Bwq-wSaFUhl-7fae7537cd2446aee43f6c213054a2ea-a73ed.jpg 120w,\n/static/Bwq-wSaFUhl-7fae7537cd2446aee43f6c213054a2ea-7f0a7.jpg 160w,\n/static/Bwq-wSaFUhl-7fae7537cd2446aee43f6c213054a2ea-02301.jpg 240w,\n/static/Bwq-wSaFUhl-7fae7537cd2446aee43f6c213054a2ea-21ad6.jpg 640w","sizes":"(max-width: 80px) 100vw, 80px","originalName":"Bwq-wSaFUhl.jpg"}}}}},{"node":{"id":"1988457784886238270","code":"BuYa9HvARw-","likes":298,"comment":5,"type":"GraphImage","text":"Tomorrow we’ll start our season with a private event at the @tacticsport headquarters in Girona. Watch this space for more!","image":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAMEBf/EABYBAQEBAAAAAAAAAAAAAAAAAAABA//aAAwDAQACEAMQAAABZa50uyjuwM9Al//EABsQAAICAwEAAAAAAAAAAAAAAAECAxEAECIS/9oACAEBAAEFAiSIkYNnONBTcebXUkSsREtf/8QAFhEAAwAAAAAAAAAAAAAAAAAAASAh/9oACAEDAQE/ATE//8QAFREBAQAAAAAAAAAAAAAAAAAAASD/2gAIAQIBAT8BI//EAB8QAAEDAwUAAAAAAAAAAAAAAAABAhEQITEiMoGRof/aAAgBAQAGPwLS5OSX2Wiu8JjBt7pdLmD/xAAaEAADAQEBAQAAAAAAAAAAAAAAARExIUFx/9oACAEBAAE/IXRstPOiJqjp5fgyDfYGnozelcF2iy8o9Kb6ELqP/9oADAMBAAIAAwAAABBTEH7/xAAYEQACAwAAAAAAAAAAAAAAAAAAARARIf/aAAgBAwEBPxC7Gij/xAAXEQEBAQEAAAAAAAAAAAAAAAABABAR/9oACAECAQE/EEJjdv/EAB0QAQADAQACAwAAAAAAAAAAAAEAESFRcYExQWH/2gAIAQEAAT8QpwcqPavU3hhdoT8lohd6qweQAUl9XiMHFYVUdPGS3qUhFDljHbTLUfGTCwtn2z//2Q==","aspectRatio":1,"src":"/static/BuYa9HvARw--8416d3734a7dcce22d8655d1f333b5ea-8a56f.jpg","srcSet":"/static/BuYa9HvARw--8416d3734a7dcce22d8655d1f333b5ea-e4adc.jpg 20w,\n/static/BuYa9HvARw--8416d3734a7dcce22d8655d1f333b5ea-e4ca8.jpg 40w,\n/static/BuYa9HvARw--8416d3734a7dcce22d8655d1f333b5ea-8a56f.jpg 80w,\n/static/BuYa9HvARw--8416d3734a7dcce22d8655d1f333b5ea-a73ed.jpg 120w,\n/static/BuYa9HvARw--8416d3734a7dcce22d8655d1f333b5ea-7f0a7.jpg 160w,\n/static/BuYa9HvARw--8416d3734a7dcce22d8655d1f333b5ea-02301.jpg 240w,\n/static/BuYa9HvARw--8416d3734a7dcce22d8655d1f333b5ea-21ad6.jpg 640w","sizes":"(max-width: 80px) 100vw, 80px","originalName":"BuYa9HvARw-.jpg"}}}}},{"node":{"id":"1973918843898395259","code":"BtkxLryA3p7","likes":132,"comment":0,"type":"GraphImage","text":"Last chance! Our sale ends tomorrow, buy our kit today and take advantage of the discount.\n•\n•\n•\n#broomwagonkit #sale #girona #newkitday #thebroomwagon","image":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAAMBAAAAAAAAAAAAAAAAAAEEBQP/xAAWAQEBAQAAAAAAAAAAAAAAAAADAQL/2gAMAwEAAhADEAAAAWVcoYuygS0+Ap6gFf/EABwQAAEEAwEAAAAAAAAAAAAAAAEAAgMRBCEyM//aAAgBAQABBQKXTC5CyMk0aJUfnl9tTOP/xAAYEQADAQEAAAAAAAAAAAAAAAAAATEQEf/aAAgBAwEBPwF04O5//8QAGBEAAwEBAAAAAAAAAAAAAAAAAAExAhD/2gAIAQIBAT8BUGzM5//EABsQAAICAwEAAAAAAAAAAAAAAAABESECEGFx/9oACAEBAAY/Ako0hVNE0jHwQ+CP/8QAHRAAAwEAAQUAAAAAAAAAAAAAAAERIUExYZGh4f/aAAgBAQABPyFuYN3XDb7SiTlSJaK5C4oESQx0XY1b2M8noH//2gAMAwEAAgADAAAAEE8fgf/EABgRAAIDAAAAAAAAAAAAAAAAAAABECEx/9oACAEDAQE/EAVIlh//xAAYEQADAQEAAAAAAAAAAAAAAAAAATEQIf/aAAgBAgEBPxCR0eDp/8QAIBABAAMAAQMFAAAAAAAAAAAAAQARITFBUdFxkaGxwf/aAAgBAQABPxB9IolKqr3b+I3aZ0H0lfpVQ5aX+wnDYJuqXzNhbMXCUAqAnPaecAuAKOhaHPQhHEOFE//Z","aspectRatio":1,"src":"/static/BtkxLryA3p7-49fcb7e80b2da348fbea6b20f0a54cce-8a56f.jpg","srcSet":"/static/BtkxLryA3p7-49fcb7e80b2da348fbea6b20f0a54cce-e4adc.jpg 20w,\n/static/BtkxLryA3p7-49fcb7e80b2da348fbea6b20f0a54cce-e4ca8.jpg 40w,\n/static/BtkxLryA3p7-49fcb7e80b2da348fbea6b20f0a54cce-8a56f.jpg 80w,\n/static/BtkxLryA3p7-49fcb7e80b2da348fbea6b20f0a54cce-a73ed.jpg 120w,\n/static/BtkxLryA3p7-49fcb7e80b2da348fbea6b20f0a54cce-7f0a7.jpg 160w,\n/static/BtkxLryA3p7-49fcb7e80b2da348fbea6b20f0a54cce-02301.jpg 240w,\n/static/BtkxLryA3p7-49fcb7e80b2da348fbea6b20f0a54cce-21ad6.jpg 640w","sizes":"(max-width: 80px) 100vw, 80px","originalName":"BtkxLryA3p7.jpg"}}}}},{"node":{"id":"1968091556927111955","code":"BtQENf4FgMT","likes":107,"comment":1,"type":"GraphImage","text":"Special offer: Buy a full set of jersey, bibs and base layer and get a 10€ discount! This offer is valid until February 8th, don’t miss out.\n•\n•\n•\n•\n#broomwagonswag \n#broomwagon #specialdeal #broomwagonkit #rideingirona #bikeandcoffee #kitoftheday #newkitdat","image":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAAMBAAAAAAAAAAAAAAAAAAMEBQL/xAAWAQEBAQAAAAAAAAAAAAAAAAABAgD/2gAMAwEAAhADEAAAAeI9WhLZaCWKIoth3//EABsQAAICAwEAAAAAAAAAAAAAAAIDAAEEERIh/9oACAEBAAEFAjEhHfRUJTIHpeOqxZqMrxHtT//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8BH//EABcRAAMBAAAAAAAAAAAAAAAAAAAQERL/2gAIAQIBAT8Bhl//xAAcEAACAQUBAAAAAAAAAAAAAAAAAQIREiAhMSL/2gAIAQEABj8Cvk/JFKWzhQae+NPH/8QAGxABAAIDAQEAAAAAAAAAAAAAAQARITFBcVH/2gAIAQEAAT8hq8hdm7XUWZu+wsEqu8ZycofexDyWJ6EwWgTVesdz/9oADAMBAAIAAwAAABCEP7z/xAAYEQACAwAAAAAAAAAAAAAAAAAAEQEQIf/aAAgBAwEBPxAcD2v/xAAWEQEBAQAAAAAAAAAAAAAAAAAQETH/2gAIAQIBAT8QwIf/xAAeEAEAAwACAgMAAAAAAAAAAAABABEhMVFBcWGRwf/aAAgBAQABPxB5aKEG1X47iBmoi+dZ5ziAVvIoIxTBIprgHPdxOgNIPK0eti1v0ag3qJpxrTuIVI8FVh+TOJ//2Q==","aspectRatio":1,"src":"/static/BtQENf4FgMT-2afaae3a7ee1f55fa10c97c6038de973-8a56f.jpg","srcSet":"/static/BtQENf4FgMT-2afaae3a7ee1f55fa10c97c6038de973-e4adc.jpg 20w,\n/static/BtQENf4FgMT-2afaae3a7ee1f55fa10c97c6038de973-e4ca8.jpg 40w,\n/static/BtQENf4FgMT-2afaae3a7ee1f55fa10c97c6038de973-8a56f.jpg 80w,\n/static/BtQENf4FgMT-2afaae3a7ee1f55fa10c97c6038de973-a73ed.jpg 120w,\n/static/BtQENf4FgMT-2afaae3a7ee1f55fa10c97c6038de973-7f0a7.jpg 160w,\n/static/BtQENf4FgMT-2afaae3a7ee1f55fa10c97c6038de973-02301.jpg 240w,\n/static/BtQENf4FgMT-2afaae3a7ee1f55fa10c97c6038de973-21ad6.jpg 640w","sizes":"(max-width: 80px) 100vw, 80px","originalName":"BtQENf4FgMT.jpg"}}}}},{"node":{"id":"1962444037454987075","code":"Bs8AHRgFn9D","likes":137,"comment":2,"type":"GraphImage","text":"Have you tried our coffee already? As you know, we love to share our passion for cycling and coffee with our community and the good news is that you can hire us for your private events as well! Where would you like to see #thebroomwagon next?\n•\n#broombroombroom #thebroomwagongirona #cyclingcoffee #girona #coffeespecialty","image":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGQABAAMBAQAAAAAAAAAAAAAAAAMEBQEC/8QAFgEBAQEAAAAAAAAAAAAAAAAAAQIA/9oADAMBAAIQAxAAAAHH1avuapJW0nRJAV//xAAcEAACAgIDAAAAAAAAAAAAAAACAwABERITIjH/2gAIAQEAAQUCHsb0LWF+rVsD2HY4ijKiOq5cT//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8BH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8BH//EAB0QAAEEAgMAAAAAAAAAAAAAAAEAAhARMUESISL/2gAIAQEABj8CF4tcm5gkH0NIB1Q6jVIdaj//xAAaEAEAAwEBAQAAAAAAAAAAAAABABEhMRBB/9oACAEBAAE/IaB7C6lEEDRs3A1RsU6QqxvDvliRD5EYDLKT/9oADAMBAAIAAwAAABAbH0L/xAAWEQEBAQAAAAAAAAAAAAAAAAAQMUH/2gAIAQMBAT8Qhp//xAAXEQADAQAAAAAAAAAAAAAAAAAAEBEx/9oACAECAQE/ENI//8QAHRABAQADAQADAQAAAAAAAAAAAREAITFBUWFxgf/aAAgBAQABPxDdsICjF+cQiCFNfu4KM7l6LE1+U9uPr2uFHrP7m3c0D0uvpjNBoHKm3CHM/9k=","aspectRatio":1,"src":"/static/Bs8AHRgFn9D-46be1024b4308115e70e0c2507e41d82-8a56f.jpg","srcSet":"/static/Bs8AHRgFn9D-46be1024b4308115e70e0c2507e41d82-e4adc.jpg 20w,\n/static/Bs8AHRgFn9D-46be1024b4308115e70e0c2507e41d82-e4ca8.jpg 40w,\n/static/Bs8AHRgFn9D-46be1024b4308115e70e0c2507e41d82-8a56f.jpg 80w,\n/static/Bs8AHRgFn9D-46be1024b4308115e70e0c2507e41d82-a73ed.jpg 120w,\n/static/Bs8AHRgFn9D-46be1024b4308115e70e0c2507e41d82-7f0a7.jpg 160w,\n/static/Bs8AHRgFn9D-46be1024b4308115e70e0c2507e41d82-02301.jpg 240w,\n/static/Bs8AHRgFn9D-46be1024b4308115e70e0c2507e41d82-21ad6.jpg 640w","sizes":"(max-width: 80px) 100vw, 80px","originalName":"Bs8AHRgFn9D.jpg"}}}}},{"node":{"id":"1945211868722527127","code":"Br-x-NwFHuX","likes":158,"comment":1,"type":"GraphImage","text":"Boats, Beautiful days and Broomwagon socks. Best combo ever!","image":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGQABAQADAQAAAAAAAAAAAAAAAAMBAgQF/8QAFwEBAQEBAAAAAAAAAAAAAAAAAgEAA//aAAwDAQACEAMQAAABhXs25rzVCl+cDyNP/8QAGhAAAwEBAQEAAAAAAAAAAAAAAAECAyEEFP/aAAgBAQABBQKejhseFU5Y7mVfsScs36fPmf/EABURAQEAAAAAAAAAAAAAAAAAABEg/9oACAEDAQE/ASP/xAAXEQADAQAAAAAAAAAAAAAAAAAAEBEh/9oACAECAQE/Aaaqf//EAB0QAAIBBAMAAAAAAAAAAAAAAAABAhEhIjEQMmH/2gAIAQEABj8C7Fk2jTLRSMnQxVeIr00f/8QAHBAAAwEAAgMAAAAAAAAAAAAAAAERITGRUWFx/9oACAEBAAE/IclcLFUQ/kUWBInYIf2nRBtTzYMOY4Y9js//2gAMAwEAAgADAAAAEH8HPv/EABgRAAMBAQAAAAAAAAAAAAAAAAABEUFR/9oACAEDAQE/EKIumER//8QAGBEAAwEBAAAAAAAAAAAAAAAAABFRATH/2gAIAQIBAT8QSDgzox//xAAcEAEAAgIDAQAAAAAAAAAAAAABABEhMUFRcWH/2gAIAQEAAT8QRjy5lU3wTZV0qGOvkekwwFXKAGG7DfdQAcjFc+HkUkJtkfIgmPWJZsuFeVe1z//Z","aspectRatio":1,"src":"/static/Br-x-NwFHuX-9d1c1afd6aa3d2d6b5c901ff1da758d8-8a56f.jpg","srcSet":"/static/Br-x-NwFHuX-9d1c1afd6aa3d2d6b5c901ff1da758d8-e4adc.jpg 20w,\n/static/Br-x-NwFHuX-9d1c1afd6aa3d2d6b5c901ff1da758d8-e4ca8.jpg 40w,\n/static/Br-x-NwFHuX-9d1c1afd6aa3d2d6b5c901ff1da758d8-8a56f.jpg 80w,\n/static/Br-x-NwFHuX-9d1c1afd6aa3d2d6b5c901ff1da758d8-a73ed.jpg 120w,\n/static/Br-x-NwFHuX-9d1c1afd6aa3d2d6b5c901ff1da758d8-7f0a7.jpg 160w,\n/static/Br-x-NwFHuX-9d1c1afd6aa3d2d6b5c901ff1da758d8-02301.jpg 240w,\n/static/Br-x-NwFHuX-9d1c1afd6aa3d2d6b5c901ff1da758d8-21ad6.jpg 640w","sizes":"(max-width: 80px) 100vw, 80px","originalName":"Br-x-NwFHuX.jpg"}}}}},{"node":{"id":"1944524698055756820","code":"Br8VukMlkwU","likes":386,"comment":4,"type":"GraphImage","text":"Not serving coffees, but actually being a Broomwagon today! 🚲🚗☀️\n•\n🚲•♥️•☕️\n•\n#Girona #broombroombroom #Coffee #Piaggio","image":{"childImageSharp":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAQCBQH/xAAWAQEBAQAAAAAAAAAAAAAAAAABAgD/2gAMAwEAAhADEAAAAehRx8RsIS+Ukswo/8QAHBAAAQQDAQAAAAAAAAAAAAAAAAECAxEEEyEy/9oACAEBAAEFAmnDOrfJOb0Jlt9DeJL6/8QAFhEBAQEAAAAAAAAAAAAAAAAAAAEQ/9oACAEDAQE/Aciv/8QAFhEBAQEAAAAAAAAAAAAAAAAAAAEQ/9oACAECAQE/AcqP/8QAHhAAAQIHAQAAAAAAAAAAAAAAABCBAQIDEiEyQZH/2gAIAQEABj8CRiFs3htUOumE/8QAHRAAAgMAAgMAAAAAAAAAAAAAAAERIUExUWFxgf/aAAgBAQABPyGGoXgJBWRUyI0N6tz6Redfc5aIS/yf/9oADAMBAAIAAwAAABC/5/7/xAAYEQADAQEAAAAAAAAAAAAAAAAAAREQMf/aAAgBAwEBPxCqxYp0f//EABgRAAIDAAAAAAAAAAAAAAAAAAAxARAh/9oACAECAQE/ENZFUP/EABwQAQEAAgMBAQAAAAAAAAAAAAERACExcbFBUf/aAAgBAQABPxAk2dS4WIxeYTLxW/ZwQFBtLv8AN4WFPyHzEORTrsxDAgeYzCkJiTXmc//Z","aspectRatio":1,"src":"/static/Br8VukMlkwU-65da74974d53d030531417878c7bdce8-8a56f.jpg","srcSet":"/static/Br8VukMlkwU-65da74974d53d030531417878c7bdce8-e4adc.jpg 20w,\n/static/Br8VukMlkwU-65da74974d53d030531417878c7bdce8-e4ca8.jpg 40w,\n/static/Br8VukMlkwU-65da74974d53d030531417878c7bdce8-8a56f.jpg 80w,\n/static/Br8VukMlkwU-65da74974d53d030531417878c7bdce8-a73ed.jpg 120w,\n/static/Br8VukMlkwU-65da74974d53d030531417878c7bdce8-7f0a7.jpg 160w,\n/static/Br8VukMlkwU-65da74974d53d030531417878c7bdce8-02301.jpg 240w,\n/static/Br8VukMlkwU-65da74974d53d030531417878c7bdce8-21ad6.jpg 640w","sizes":"(max-width: 80px) 100vw, 80px","originalName":"Br8VukMlkwU.jpg"}}}}}]}},"layoutContext":{}}

/***/ }),

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(148);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(85);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(233);
	var isArguments = __webpack_require__(232);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 232:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 233:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(9);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(13);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(12);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(31);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends3.default)({}, props);
	  if (convertedProps.responsiveResolution) {
	    convertedProps.resolutions = convertedProps.responsiveResolution;
	    delete convertedProps.responsiveResolution;
	  }
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes ? convertedProps.sizes.src : convertedProps.resolutions.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	
	function getIO() {
	  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
	    io = new window.IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        listeners.forEach(function (l) {
	          if (l[0] === entry.target) {
	            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	            if (entry.isIntersecting || entry.intersectionRatio > 0) {
	              io.unobserve(l[0]);
	              l[1]();
	            }
	          }
	        });
	      });
	    }, { rootMargin: "200px" });
	  }
	
	  return io;
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  getIO().observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var noscriptImg = function noscriptImg(props) {
	  // Check if prop exists before adding each attribute to the string output below to prevent
	  // HTML validation issues caused by empty values like width="" and height=""
	  var src = props.src ? "src=\"" + props.src + "\" " : "src=\"\" "; // required attribute
	  var srcSet = props.srcSet ? "srcset=\"" + props.srcSet + "\" " : "";
	  var sizes = props.sizes ? "sizes=\"" + props.sizes + "\" " : "";
	  var title = props.title ? "title=\"" + props.title + "\" " : "";
	  var alt = props.alt ? "alt=\"" + props.alt + "\" " : "alt=\"\" "; // required attribute
	  var width = props.width ? "width=\"" + props.width + "\" " : "";
	  var height = props.height ? "height=\"" + props.height + "\" " : "";
	  var opacity = props.opacity ? props.opacity : "1";
	  var transitionDelay = props.transitionDelay ? props.transitionDelay : "0.5s";
	
	  return "<img " + width + height + src + srcSet + alt + title + sizes + "style=\"position:absolute;top:0;left:0;transition:opacity 0.5s;transition-delay:" + transitionDelay + ";opacity:" + opacity + ";width:100%;height:100%;object-fit:cover;object-position:center\"/>";
	};
	
	var Img = function Img(props) {
	  var style = props.style,
	      onLoad = props.onLoad,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ["style", "onLoad"]);
	
	  return _react2.default.createElement("img", (0, _extends3.default)({}, otherProps, {
	    onLoad: onLoad,
	    style: (0, _extends3.default)({
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }, style)
	  }));
	};
	
	Img.propTypes = {
	  style: _propTypes2.default.object,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image(props) {
	    (0, _classCallCheck3.default)(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        _convertProps$imgStyl = _convertProps.imgStyle,
	        imgStyle = _convertProps$imgStyl === undefined ? {} : _convertProps$imgStyl,
	        _convertProps$placeho = _convertProps.placeholderStyle,
	        placeholderStyle = _convertProps$placeho === undefined ? {} : _convertProps$placeho,
	        sizes = _convertProps.sizes,
	        resolutions = _convertProps.resolutions,
	        backgroundColor = _convertProps.backgroundColor,
	        Tag = _convertProps.Tag;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    var imagePlaceholderStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded ? 0 : 1,
	      transitionDelay: "0.25s"
	    }, imgStyle, placeholderStyle);
	
	    var imageStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0
	    }, imgStyle);
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: (0, _extends3.default)({
	              position: "relative",
	              overflow: "hidden"
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement(Tag, {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64,
	            style: imagePlaceholderStyle
	          }),
	          image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({ alt: alt, title: title }, image))
	            }
	          })
	        )
	      );
	    }
	
	    if (resolutions) {
	      var _image = resolutions;
	      var divStyle = (0, _extends3.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      // Use webp by default if browser supports it
	      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
	        _image.src = _image.srcWebp;
	        _image.srcSet = _image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: divStyle,
	            ref: this.handleRef
	          },
	          _image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.base64,
	            style: imagePlaceholderStyle
	          }),
	          _image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              width: _image.width,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.25s",
	              height: _image.height
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height,
	            srcSet: _image.srcSet,
	            src: _image.src,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({
	                alt: alt,
	                title: title,
	                width: _image.width,
	                height: _image.height
	              }, _image))
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: "",
	  Tag: "div"
	};
	
	Image.propTypes = {
	  responsiveResolution: _propTypes2.default.object,
	  responsiveSizes: _propTypes2.default.object,
	  resolutions: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  imgStyle: _propTypes2.default.object,
	  placeholderStyle: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func,
	  Tag: _propTypes2.default.string
	};
	
	exports.default = Image;

/***/ }),

/***/ 6:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.OutboundLink = undefined;
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function OutboundLink(props) {
	  return _react2.default.createElement("a", (0, _extends3.default)({}, props, {
	    onClick: function onClick(e) {
	      if (typeof props.onClick === "function") {
	        props.onClick();
	      }
	      var redirect = true;
	      if (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey || e.defaultPrevented) {
	        redirect = false;
	      }
	      if (props.target && props.target.toLowerCase() !== "_self") {
	        redirect = false;
	      }
	      if (window.ga) {
	        window.ga("send", "event", {
	          eventCategory: "Outbound Link",
	          eventAction: "click",
	          eventLabel: props.href,
	          transport: redirect ? "beacon" : "",
	          hitCallback: function hitCallback() {
	            if (redirect) {
	              document.location = props.href;
	            }
	          }
	        });
	      } else {
	        if (redirect) {
	          document.location = props.href;
	        }
	      }
	
	      return false;
	    }
	  }));
	}
	
	OutboundLink.propTypes = {
	  href: _propTypes2.default.string,
	  target: _propTypes2.default.string,
	  onClick: _propTypes2.default.func
	};
	
	exports.OutboundLink = OutboundLink;

/***/ }),

/***/ 372:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(391);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(231);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(373);
	
	var _HelmetConstants = __webpack_require__(121);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 121:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 373:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(86);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(121);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 391:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(2);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(240));
	var shallowEqual = _interopDefault(__webpack_require__(398));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 398:
/***/ (function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ }),

/***/ 39:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 358:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 359:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 360:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 361:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 362:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 365:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 366:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 367:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 43:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  site: {
	    title: 'The Broomwagon',
	    subtitle: 'Girona',
	    caption: 'best coffee experience on location',
	
	    description: 'The Broomwagon. World-class coffee on (three) wheels based in Girona. Bring the Broomwagon to your event to provide your guests with an amazing coffee experience on location. Go to our web shop to buy our beautiful kit!',
	
	    url: 'https://www.thebroomwagongirona.com', // Domain of your site. No trailing slash!
	    // url: 'https://broomwagongirona.netlify.com', // Domain of your site. No trailing slash!
	    pathPrefix: '/', // Prefix for all links. If you deploy your site to example.com/portfolio your pathPrefix should be "portfolio"
	    siteLanguage: 'en', // Language Tag on <html> element
	    siteLogo: '/images/logo.jpg' // Used for SEO and manifest
	  },
	  directus_api: {
	    // url: `http://localhost`,
	    url: 'api.thebroomwagongirona.com',
	    protocol: 'http',
	    apiKey: 'etIfgwbpyKszCdBPYh7dUsYDyX8oDk3Y'
	  },
	  google: {
	    analyticsID: 'UA-19600184-9'
	  }
	};

/***/ }),

/***/ 30:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyPluginGoogleAnalytics = __webpack_require__(6);
	
	__webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CTA = function CTA(props) {
	  return props.external ? _react2.default.createElement(
	    _gatsbyPluginGoogleAnalytics.OutboundLink,
	    { rel: 'nofollow', className: 'cta' + (props.light ? " light" : "") + ' ' + (props.className ? props.className : ""), href: props.to, target: '_blank' },
	    props.label
	  ) : _react2.default.createElement(
	    _gatsbyLink2.default,
	    { className: 'cta' + (props.light ? " light" : "") + ' ' + (props.className && props.className), to: props.to },
	    props.label
	  );
	};
	
	exports.default = CTA;
	module.exports = exports['default'];

/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(358);
	
	var _gatsbyPluginGoogleAnalytics = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Copyright = function Copyright(props) {
	  return _react2.default.createElement(
	    'span',
	    { className: 'copyright' },
	    'Copyright \xA9 the Broomwagon - ',
	    new Date().getFullYear(),
	    '. All Rights Reserved. Tailor made by ',
	    _react2.default.createElement(
	      _gatsbyPluginGoogleAnalytics.OutboundLink,
	      { href: 'https://www.web-hart.com/', target: '_blank' },
	      'WEBhart'
	    ),
	    '.'
	  );
	};
	
	exports.default = Copyright;
	module.exports = exports['default'];

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Copyright = __webpack_require__(136);
	
	var _Copyright2 = _interopRequireDefault(_Copyright);
	
	__webpack_require__(359);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Footer = function (_React$Component) {
	  _inherits(Footer, _React$Component);
	
	  function Footer(props) {
	    _classCallCheck(this, Footer);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    // this.state = {
	    //   valid: {
	    //     name: false,
	    //     email: false,
	    //     message: false,
	    //   },
	    // };
	  }
	
	  // validateMail(mail) {
	  //   const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	  //   return re.test(String(mail).toLowerCase());
	  // }
	
	  // validate(element) {
	  //   let isValid = false;
	  //   const validState = this.state.valid;
	
	  //   if (element.target.value.length > 0) {
	  //     if (element.target.name === 'email' && !this.validateMail(element.target.value)) {
	  //       isValid = false;
	  //     } else {
	  //       isValid = true;
	  //     }
	  //   }
	
	  //   if (isValid) {
	  //     element.target.className = 'valid';
	  //     validState[element.target.name] = true;
	  //   } else {
	  //     element.target.className = 'invalid';
	  //     validState[element.target.name] = false;
	  //   }
	  //   this.setState({ valid: validState });
	  //   if (this.state.valid.name && this.state.valid.email && this.state.valid.message) {
	  //     document.getElementById('form-submit').className = 'valid';
	  //     document.getElementById('form-submit').disabled = false;
	  //   } else {
	  //     document.getElementById('form-submit').className = 'invalid';
	  //     document.getElementById('form-submit').disabled = true;
	  //   }
	  // }
	
	  Footer.prototype.render = function render() {
	    return _react2.default.createElement(
	      'footer',
	      { className: 'footer' },
	      _react2.default.createElement(
	        'h2',
	        null,
	        'contact'
	      ),
	      _react2.default.createElement(
	        'form',
	        {
	          action: '/?no-cache=1',
	          id: 'contact',
	          name: 'contact-form',
	          'data-netlify': 'true',
	          'netlify-honeypot': 'bot-field',
	          method: 'POST'
	        },
	        _react2.default.createElement('input', { name: 'bot-field', className: 'visually-hidden' }),
	        _react2.default.createElement(
	          'label',
	          { className: 'name-field' },
	          'Name',
	          _react2.default.createElement('input', {
	            // onChange={(e) => this.validate(e)}
	            type: 'text',
	            name: 'name',
	            required: true
	          })
	        ),
	        _react2.default.createElement(
	          'label',
	          { className: 'mail-field' },
	          'Email',
	          _react2.default.createElement('input', {
	            // onChange={(e) => this.validate(e)}
	            type: 'email',
	            name: 'email',
	            required: true
	          })
	        ),
	        _react2.default.createElement(
	          'label',
	          { className: 'message-field' },
	          'Message',
	          _react2.default.createElement('textarea', {
	            // onChange={(e) => this.validate(e)}
	            name: 'message',
	            required: true
	          })
	        ),
	        _react2.default.createElement(
	          'button',
	          { type: 'submit', id: 'form-submit' },
	          'Send'
	        )
	      ),
	      _react2.default.createElement(_Copyright2.default, null)
	    );
	  };
	
	  return Footer;
	}(_react2.default.Component);
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(360);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Hamburger = function Hamburger(props) {
	  return _react2.default.createElement(
	    'button',
	    { onClick: props.handleClick, className: 'hamburger hamburger--spin ' + (props.isMenuVisible ? ' is-active' : ''), type: 'button' },
	    _react2.default.createElement(
	      'span',
	      { className: 'hamburger-box' },
	      _react2.default.createElement('span', { className: 'hamburger-inner' })
	    )
	  );
	};
	
	exports.default = Hamburger;
	module.exports = exports['default'];

/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Hamburger = __webpack_require__(139);
	
	var _Hamburger2 = _interopRequireDefault(_Hamburger);
	
	var _gatsbyPluginGoogleAnalytics = __webpack_require__(6);
	
	__webpack_require__(361);
	
	var _cart = __webpack_require__(399);
	
	var _cart2 = _interopRequireDefault(_cart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header(props) {
	  return _react2.default.createElement(
	    'header',
	    { className: 'header' },
	    _react2.default.createElement(_Hamburger2.default, { handleClick: props.menuClick, isMenuVisible: props.isMenuVisible }),
	    _react2.default.createElement(
	      'p',
	      null,
	      props.title,
	      _react2.default.createElement(
	        'span',
	        null,
	        props.subtitle
	      )
	    ),
	    _react2.default.createElement(
	      _gatsbyPluginGoogleAnalytics.OutboundLink,
	      { href: '#', className: 'snipcart-checkout snipcart-summary' },
	      _react2.default.createElement('img', { src: _cart2.default, alt: 'cart' }),
	      _react2.default.createElement('span', { className: 'snipcart-total-items' })
	    )
	  );
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(10);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _gatsbyPluginGoogleAnalytics = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InstaImage = function InstaImage(props) {
	  return _react2.default.createElement(
	    _gatsbyPluginGoogleAnalytics.OutboundLink,
	    { rel: 'nofollow', className: 'instaImage ' + props.postData.type, href: 'https://www.instagram.com/p/' + props.postData.code, target: '_blank' },
	    _react2.default.createElement(_gatsbyImage2.default, { alt: props.postData.text, sizes: props.postData.image.childImageSharp.sizes }),
	    _react2.default.createElement(
	      'span',
	      { className: 'postLikes' },
	      props.postData.likes
	    )
	  );
	};
	
	exports.default = InstaImage;
	module.exports = exports['default'];

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(362);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Menu = function Menu(props) {
	  return _react2.default.createElement(
	    'nav',
	    { className: 'menu' },
	    _react2.default.createElement(
	      'ul',
	      { className: 'links' },
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { onClick: props.menuClick, to: '/' },
	          'Home'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { onClick: props.menuClick, to: '/webshop/' },
	          'webshop'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { onClick: props.menuClick, to: '/experiences/' },
	          'experiences'
	        )
	      )
	    )
	  );
	};
	
	exports.default = Menu;
	module.exports = exports['default'];

/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(372);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _settings = __webpack_require__(43);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SEO = function SEO(_ref) {
	  var pageName = _ref.pageName;
	
	  var config = _settings2.default.site;
	  var title = config.title + " " + config.subtitle;
	  var altTitle = title + " \u2014 " + config.caption;
	  var description = config.description;
	  var realPrefix = config.pathPrefix === '/' ? '' : config.pathPrefix;
	  var image = config.url + realPrefix + config.siteLogo;
	  var logo = config.url + realPrefix + config.siteLogo;
	  var realURL = config.url + config.pathPrefix;
	
	  var schemaOrgJSONLD = [{
	    "@context": "http://schema.org/",
	    "@type": "CafeOrCoffeeShop",
	    "url": realURL,
	    "name": title,
	    "alternateName": altTitle,
	    "description": description,
	    "currenciesAccepted": "EUR",
	    "priceRange": "€€",
	    "servesCuisine": "coffee",
	    "telephone": "000",
	    "paymentAccepted": "cash",
	    "address": {
	      "@type": "PostalAddress",
	      "addressCountry": "Spain",
	      "addressRegion": "Catalonia",
	      "postalCode": "17001",
	      "streetAddress": "Girona"
	    },
	    "email": "info@thebroomwagongirona.com",
	    "founder": {
	      "@type": "Person",
	      "familyName": "Gesink",
	      "givenName": "Robert",
	      "jobTitle": "Pro Cyclist",
	      "name": "Robert Gesink"
	    },
	    "image": image,
	    "logo": logo
	  }];
	  return _react2.default.createElement(
	    _reactHelmet2.default,
	    null,
	    _react2.default.createElement("html", { lang: config.siteLanguage }),
	    _react2.default.createElement(
	      "title",
	      null,
	      altTitle
	    ),
	    _react2.default.createElement("meta", { charSet: "utf-8" }),
	    _react2.default.createElement("meta", { httpEquiv: "X-UA-Compatible", content: "IE=edge,chrome=1" }),
	    _react2.default.createElement("meta", { name: "viewport", content: "width=device-width, initial-scale=1" }),
	    _react2.default.createElement("meta", { name: "description", content: description }),
	    _react2.default.createElement("meta", { name: "image", content: image }),
	    _react2.default.createElement(
	      "script",
	      { type: "application/ld+json" },
	      JSON.stringify(schemaOrgJSONLD)
	    ),
	    _react2.default.createElement("meta", { property: "og:site_name", content: altTitle }),
	    _react2.default.createElement("meta", { property: "og:title", content: title }),
	    _react2.default.createElement("meta", { property: "og:description", content: description }),
	    _react2.default.createElement("meta", { property: "og:image", content: image }),
	    _react2.default.createElement("meta", { name: "twitter:card", content: "summary_large_image" }),
	    _react2.default.createElement("meta", { name: "twitter:title", content: title }),
	    _react2.default.createElement("meta", { name: "twitter:description", content: description }),
	    _react2.default.createElement("meta", { name: "twitter:image", content: image })
	  );
	};
	
	exports.default = SEO;
	module.exports = exports["default"];

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(10);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _InstaImage = __webpack_require__(141);
	
	var _InstaImage2 = _interopRequireDefault(_InstaImage);
	
	var _CTA = __webpack_require__(30);
	
	var _CTA2 = _interopRequireDefault(_CTA);
	
	var _logo = __webpack_require__(400);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	__webpack_require__(365);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Sidebar = function (_React$Component) {
	  _inherits(Sidebar, _React$Component);
	
	  function Sidebar(props) {
	    _classCallCheck(this, Sidebar);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  Sidebar.prototype.render = function render() {
	    return _react2.default.createElement(
	      'aside',
	      { className: 'sidebar' },
	      _react2.default.createElement('img', { alt: 'logo', className: 'logo', src: _logo2.default }),
	      _react2.default.createElement(
	        'div',
	        { className: 'instaWrap' },
	        _react2.default.createElement(
	          'div',
	          { className: 'instaUserInfo' },
	          _react2.default.createElement(
	            'p',
	            { className: 'instaPosts' },
	            this.props.instagramUser.userPostCount,
	            ' posts'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'instaFollowers' },
	            this.props.instagramUser.userFollowers,
	            ' followers'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'instaBio' },
	            this.props.instagramUser.userBio
	          ),
	          _react2.default.createElement(_CTA2.default, { external: true, to: 'https://www.instagram.com/' + this.props.instagramUser.userName, className: 'instafollow', label: '@' + this.props.instagramUser.userName })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'instaImages' },
	          _react2.default.createElement(_InstaImage2.default, { key: '0', postData: this.props.instagramUser }),
	          this.props.instagramPosts.map(function (_ref, index) {
	            var node = _ref.node;
	
	            if (index > 0) return _react2.default.createElement(_InstaImage2.default, { key: index, postData: node });
	          })
	        )
	      )
	    );
	  };
	
	  return Sidebar;
	}(_react2.default.Component);
	
	exports.default = Sidebar;
	module.exports = exports['default'];

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.indexLayoutQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SEO = __webpack_require__(145);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _Header = __webpack_require__(140);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Sidebar = __webpack_require__(146);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _Menu = __webpack_require__(142);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Footer = __webpack_require__(138);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _settings = __webpack_require__(43);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	__webpack_require__(367);
	
	__webpack_require__(366);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexTemplateWrapper = function (_React$Component) {
	  _inherits(IndexTemplateWrapper, _React$Component);
	
	  function IndexTemplateWrapper(props) {
	    _classCallCheck(this, IndexTemplateWrapper);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      isMenuVisible: false
	    };
	    _this.handleToggleMenu = _this.handleToggleMenu.bind(_this);
	    _this.completeOrder = _this.completeOrder.bind(_this);
	    // this.checkDiscount = this.checkDiscount.bind(this);
	    return _this;
	  }
	
	  IndexTemplateWrapper.prototype.componentDidMount = function componentDidMount() {
	    Snipcart.subscribe('order.completed', function (data) {
	      return completeOrder(data);
	    });
	  };
	
	  IndexTemplateWrapper.prototype.completeOrder = function completeOrder(data) {
	    var updateItems = [];
	    data.items.map(function (item, index) {
	      var itemID = item.id.replace('product_', '');
	      var quantity = item.maxQuantity - item.quantity;
	
	      updateItems.push({
	        id: itemID,
	        count: quantity
	      });
	    });
	
	    var url = _settings2.default.directus_api.protocol + '://' + _settings2.default.directus_api.url + '/api/1.1/tables/stock/rows/bulk';
	
	    fetch(url, {
	      method: 'put',
	      body: JSON.stringify({ rows: updateItems }),
	      headers: new Headers({
	        'Content-Type': 'application/json; charset=utf-8',
	        Authorization: 'Bearer ' + _settings2.default.directus_api.apiKey,
	        'Access-Control-Request-Method': 'PUT'
	      })
	    }).then(function (res) {
	      return res.json();
	    }).then(function (result) {
	      console.log(result);
	    },
	    // Note: it's important to handle errors here
	    // instead of a catch() block so that we don't swallow
	    // exceptions from actual bugs in components.
	    function (error) {
	      console.log(error);
	    });
	  };
	
	  IndexTemplateWrapper.prototype.handleToggleMenu = function handleToggleMenu() {
	    this.setState({
	      isMenuVisible: !this.state.isMenuVisible
	    });
	  };
	
	  IndexTemplateWrapper.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'index ' + (this.state.isMenuVisible ? 'is-menu-visible' : '') },
	      _react2.default.createElement(_SEO2.default, { pageName: this.props.location.pathname }),
	      _react2.default.createElement(_Sidebar2.default, {
	        instagramUser: this.props.data.user.edges[0].node,
	        instagramPosts: this.props.data.posts.edges
	      }),
	      _react2.default.createElement(_Header2.default, {
	        title: _settings2.default.site.title,
	        subtitle: _settings2.default.site.subtitle,
	        menuClick: this.handleToggleMenu,
	        isMenuVisible: this.state.isMenuVisible
	      }),
	      _react2.default.createElement(
	        'main',
	        null,
	        _react2.default.createElement(_Menu2.default, { menuClick: this.handleToggleMenu }),
	        this.props.children(),
	        _react2.default.createElement(_Footer2.default, null)
	      )
	    );
	  };
	
	  return IndexTemplateWrapper;
	}(_react2.default.Component);
	
	IndexTemplateWrapper.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = IndexTemplateWrapper;
	var indexLayoutQuery = exports.indexLayoutQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 399:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNC4yMTcgMjAuNSI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6bm9uZTtzdHJva2U6IzVjYjhiNTtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7c3Ryb2tlLW1pdGVybGltaXQ6MTA7c3Ryb2tlLXdpZHRoOjEuNXB4O308L3N0eWxlPjwvZGVmcz48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjI1IDAuMjUpIj48cGF0aCBjbGFzcz0iYSIgZD0iTTcuNSwzLjVIMjIuMmExLjA0NCwxLjA0NCwwLDAsMSwxLDEuM2wtMS42LDUuN2gtMTEiLz48cGF0aCBjbGFzcz0iYSIgZD0iTS41LjVIMi44YTEuMiwxLjIsMCwwLDEsMSwuN0w3LjQsMTIuOGEuOTkzLjk5MywwLDAsMCwxLC43SDIyLjciLz48Y2lyY2xlIGNsYXNzPSJhIiBjeD0iMiIgY3k9IjIiIHI9IjIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDcuNSAxNS41KSIvPjxjaXJjbGUgY2xhc3M9ImEiIGN4PSIyIiBjeT0iMiIgcj0iMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTguNSAxNS41KSIvPjwvZz48L3N2Zz4="

/***/ }),

/***/ 400:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo.6b0c31fe.svg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-ac6026fa0672bcee6812.js